import { t } from "./share";

export const EMULATIING = process.env.NODE_ENV === "development";

export const themeAppId = EMULATIING
  ? "b9f1659b-33f5-4a88-91d0-ba0a05b27aef"
  : "7c185fb9-624c-43e5-b4ae-0b636aa2bb96";

export const params = EMULATIING
  ? {
      apiKey: "d7aab1e09e76c1ebe37cd65aa84163c1",
      host: "http://localhost:5002",
      frontHost: "http://localhost:3003",
      scopes: "write_validations,write_products",
      handle: "functions-test-57",
    }
  : {
      apiKey: "76008a21bd23c79fd3f8d17ce52803d3",
      host: "https://sh-term-of-use.web.app",
      scopes: "",
      frontHost: "https://sh-term-of-use.web.app",
      handle: "riyou-kiyaku",
    };

export const idStrs = {
  variants: "gid://shopify/ProductVariant/",
  products: "gid://shopify/Product/",
};

export const sleep = (second: number) =>
  new Promise((resolve) => setTimeout(resolve, second * 1000));

export const getPlans = () => {
  const descriptions = [
    t("商品毎の数量制限", "Quantity limit"),
    t("販売期間", "Term Limit"),
    t("同時購入制限", "Simultaneous purchase limit"),
    t("顧客毎の制限", " Customer Limit"),
  ];

  const plans = () => {
    return {
      normal: {
        name: t("CC Checkbox (利用規約を追加するアプリ)", "CC Checkbox"),
        price: 1.99,
        sName: t("ノーマル", "Normal"),
        descriptions: descriptions.slice(0, 1),
        tone: "info",
      },
    } as {
      [key: string]: {
        name: string;
        price: number;
        sName: string;
        descriptions: string[];
        tone: "info" | "attention" | "magic";
      };
    };
  };

  return plans();
};

export enum statusEnum {
  ok = "ok",
  sNg = "session-ng",
}

export const sessionNgModalProps = {
  open: true,
  message: t(
    "sessionエラーです。リロードします。",
    "session is error. to be reload"
  ),
};
